import styled from "styled-components";

/**
 * Externalized styles for {@link ./LoginPage} (owner externalized-styles rule, 2026-07-12).
 *
 * `flex: 1 0 auto` rather than `min-height: 100vh` since ui#2394 put a legal footer row at the foot of
 * the app scroller. A page that demands a whole viewport for itself leaves the row stacked underneath
 * it, which is a page that scrolls by exactly the footer's height with the statutory cancellation
 * control below the fold — measured at 67px on 1280x800 and 65px on 375x667 before this line changed.
 * Filling the space that is LEFT keeps the full-bleed look and puts the row on screen. It still never
 * shrinks below its own content (`flex-shrink: 0`), so a short window scrolls the page rather than
 * squashing the card.
 *
 * `vh` was also the wrong unit here for the reason `AppComponents`' `Main` documents: on a mobile
 * browser it is the LARGE viewport, so the page was taller than what the visitor can see whenever the
 * address bar is showing.
 */
export const Shell = styled.div`
	position: relative;
	flex: 1 0 auto;
	overflow: hidden;
`;
